import AsyncStorage from '@react-native-async-storage/async-storage';

export enum StorageKeys {
  theme = 'theme',
  token = 'token',
  locality = 'locality',
  fcmToken = 'fcmToken',
  fcmTokenCheckTime = 'fcmTokenCheckTime',
  fcmInitialMessage = 'fcmInitialMessage',
  pinCode = 'pinCode',
  recoveryCodeId = 'recoveryCodeId',
  confirmCodeId = 'confirmCodeId',
  changeContactsCodeId = 'changeContactsCodeId',
  changeContactsCodeIdUsage = 'changeContactsCodeIdUsage',
  visuallyImpaired = 'visuallyImpaired',
  fontSize = 'fontSize',
  switchColor = 'switchColor',
  switchImages = 'switchImages',
  letterSpacing = 'letterSpacing',
  fontStyle = 'fontStyle',
  api = 'api',
  isESIA = 'isESIA',
  activationToken = 'activationToken',
  cardReissueEsiaPending = 'cardReissueEsiaPending',
  cardReissueExpectedSnils = 'cardReissueExpectedSnils',
  esiaRegInfo = 'esiaRegInfo',
}

const castValueToStorage = (value: unknown): string => {
  switch (typeof value) {
    case 'number': {
      return value.toString();
    }
    case 'string': {
      return value;
    }
    case 'boolean': {
      return (value ? 1 : 0).toString();
    }
    default: {
      return JSON.stringify(value);
    }
  }
};

interface Storage {
  setItem<T>(key: StorageKeys, value: T, asJson?: boolean): Promise<void>;
  getItem<T>(key: StorageKeys, asJson?: boolean): Promise<T | null>;
  removeItem(key: StorageKeys): Promise<void>;
}

export const storage: Storage = {
  async setItem(key: StorageKeys, value: unknown, asJson = true) {
    try {
      const str = asJson ? JSON.stringify(value) : castValueToStorage(value);
      await AsyncStorage.setItem(key, str);
    } catch (e) {
      console.error(e);
    }
  },
  async getItem<T>(key: StorageKeys, asJson = true) {
    try {
      const value = await AsyncStorage.getItem(key);
      if (!value) {
        return null;
      }

      // @ts-ignore
      return asJson ? (JSON.parse(value) as T) : (value as T);
    } catch (e) {
      console.error(e);

      return null;
    }
  },
  async removeItem(key: StorageKeys) {
    try {
      return AsyncStorage.removeItem(key);
    } catch (e) {
      console.error(e);
    }
  },
};
